(function() {
  var domUtil;

  domUtil = exports;

  domUtil.isVerticallyVisibleWithin = (function(_this) {
    return function(elem, relative_to) {
      var contBottom, contHeight, contTop, container, elemBottom, elemTop, isPart, isTotal;
      container = $(elem).closest(relative_to);
      contHeight = container.height();
      contTop = container.scrollTop();
      contBottom = contTop + contHeight;
      if (container.offset() != null) {
        elemTop = $(elem).offset().top - container.offset().top;
        elemBottom = elemTop + $(elem).height();
        isTotal = elemTop >= 0 && elemBottom <= contHeight;
        isPart = (elemTop < 0 && elemBottom > 0) || (elemTop > 0 && elemTop <= container.height());
        return isTotal || isPart;
      }
    };
  })(this);

}).call(this);
